export default "__VITE_ASSET__BXk4cCVS__"